var themeNames = Object.freeze({
   DAWN: 'dawn',
   DUSK: 'dusk'
});

export default themeNames;
